import React, { useEffect, useState } from 'react';
import { useNavigate, useLocation } from "react-router-dom";
import LoginModal from '../../../../components/customer/auth/loginModal/LoginModal';
import WorkerRegister from '../../../../components/serviceprovider/workerauth/WorkerAuth';
import { Menu, User, UserPlus, Home, Grid, BookOpen, Info, Phone, Hammer } from 'lucide-react';
import "../../../../assets/css/components/customer/home/Navbar/MyNavbar.css";
// import logo from '../../../../assets/images/logoo.jpg';
import logo from '../../../../assets/images/logo.png';

const MyNavbar = () => {
  const navigate = useNavigate();
  const location = useLocation();

  const [isTransparent, setIsTransparent] = useState(false);

  useEffect(() => {
    const handleScroll = () => {
      const heroSections = document.querySelectorAll(".hero-section");
      let overHero = false;
      heroSections.forEach(section => {
        const rect = section.getBoundingClientRect();
        if (rect.top <= 60 && rect.bottom > 0) overHero = true;
      });
      setIsTransparent(overHero);
    };
    window.addEventListener("scroll", handleScroll);
    handleScroll();
    return () => window.removeEventListener("scroll", handleScroll);
  }, []);

  const navbarStyle = {
    background: isTransparent ? "transparent" : "#484745",
    transition: "all 0.3s ease",
    position: "fixed",
    top: 0, left: 0, width: "100%", zIndex: 999,
  };

  const [isScrolled, setIsScrolled] = useState(false);
  const [isMobileMenuOpen, setIsMobileMenuOpen] = useState(false);
  const [showLoginModal, setShowLoginModal] = useState(false);
  const [showRegister, setShowRegister] = useState(false);
  const [isLoggedIn, setIsLoggedIn] = useState(false);
  const [userData, setUserData] = useState({
    name: 'Ali Raza', email: 'ali@example.com',
    avatar: 'https://ui-avatars.com/api/?name=Ali+Raza&background=004538&color=fff'
  });

  useEffect(() => {
    const handleScroll = () => setIsScrolled(window.scrollY > 20);
    window.addEventListener('scroll', handleScroll);
    return () => window.removeEventListener('scroll', handleScroll);
  }, []);

  const handleLoginSuccess = (user) => {
    setIsLoggedIn(true);
    setUserData(user);
    setShowLoginModal(false);
  };

  const handleLogout = () => { setIsLoggedIn(false); navigate('/'); };

  return (
    <>
      <nav className={`navbar ${isScrolled ? 'navbar-scrolled' : ''}`} style={navbarStyle}>
        <div className="navbar-container">
          <div className="navbar-content">

           {/* Logo */}
<div className="navbar-logo" onClick={() => navigate('/')}>
  <img src={logo} alt="Picks4Tips" className="navbar-logo__img" />
</div>

            <div className="navbar-menu">
              <a className={`nav-link ${location.pathname === '/' ? 'nav-link-active' : ''}`} onClick={() => navigate('/')}>HOME</a>
              <a className={`nav-link ${location.pathname === '/services' ? 'nav-link-active' : ''}`} onClick={() => navigate('/services')}>CATEGORY</a>
              <a className={`nav-link ${location.pathname === '/blogs' ? 'nav-link-active' : ''}`} onClick={() => navigate('/blogs')}>BLOGS</a>
              <a className={`nav-link ${location.pathname === '/about-us' ? 'nav-link-active' : ''}`} onClick={() => navigate('/about-us')}>ABOUT US</a>
              {/* <a className={`nav-link ${location.pathname === '/contact' ? 'nav-link-active' : ''}`} onClick={() => navigate('/contact')}>CONTACT</a> */}
              <button className="nav-link nav-btn" onClick={() => setShowLoginModal(true)}><User size={18} /> LOGIN</button>
              <button className="btn-provider" onClick={() => setShowRegister(true)}><UserPlus size={18} /> Become A Responder</button>
            </div>

            <button className="mobile-menu-btn" onClick={() => setIsMobileMenuOpen(!isMobileMenuOpen)}>
              <Menu size={28} />
            </button>
          </div>
        </div>
      </nav>

      {/* ── Mobile top buttons — elegant pill style ── */}
      {location.pathname === '/' && (
        <div className="mobile-top-btns">
          <button className="mob-btn mob-btn--provider" onClick={() => setShowRegister(true)}>
            <Hammer size={14} /> Become A Responder
          </button>
          <button className="mob-btn mob-btn--login" onClick={() => setShowLoginModal(true)}>
            <User size={14} /> Log in
          </button>

        </div>
      )}

      {/* Mobile Bottom Nav */}
      <div className="mobile-bottom-nav">
        <button onClick={() => navigate('/')}><Home size={20} /><span>Home</span></button>
        <button onClick={() => navigate('/services')}><Grid size={20} /><span>Category</span></button>
        <button onClick={() => navigate('/blogs')}><BookOpen size={20} /><span>Blogs</span></button>
        <button onClick={() => navigate('/about-us')}><Info size={20} /><span>About us</span></button>
        {/* <button onClick={() => navigate('/contact')}><Phone size={20} /><span>Contact</span></button> */}
      </div>

      {showRegister && (
        <WorkerRegister
          onClose={() => setShowRegister(false)}
          onSwitchToLogin={() => { setShowRegister(false); setShowLoginModal(true); }}
        />
      )}

      {showLoginModal && (
        <LoginModal
          isOpen={showLoginModal}
          onClose={() => setShowLoginModal(false)}
          onLoginSuccess={handleLoginSuccess}
        />
      )}
    </>
  );
};

export default MyNavbar;